/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-16 11:05:48
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-16 17:09:54
 */
import * as Domain from '@/utils/methods/domain'

/**
 * @brief: 获取cookie的值
 * @author: Scarlett Xiao
 * @Date: 2022-03-16 13:41:39
 * @param {*} key cookie 对应的 kie值
 */
export function getCookie(key) {
  var arrStr = document.cookie.split("; ");
  for (var i = 0; i < arrStr.length; i++) {
    var temp = arrStr[i].split("=");
    if (temp[0] == key) return unescape(temp[1]);
  }
}
/**
 * @brief: 添加 cookie
 * @author: Scarlett Xiao
 * @Date: 2022-03-16 13:41:09
 * @param {*} key ky值
 * @param {*} value value值
 * @param {*} hours  保存小时数
 */
export function addCookie(key, value, hours) {
  var str = key + "=" + escape(value);
  if (hours && hours > 0) {
    //为时不设定过期时间，浏览器关闭时cookie自动消失
    var date = new Date();
    var ms = hours * 3600 * 1000;
    date.setTime(date.getTime() + ms);
    str += "; expires=" + date.toUTCString();
  }
  document.cookie = str;
}
/**
 * @brief: 移除cookie
 * @author: Scarlett Xiao
 * @Date: 2022-03-16 13:40:47
 * @param {*} key cookie对应key值
 */
export function delCookie(key) {
  document.cookie = key + "=;expires=" + new Date(0).toUTCString();
}
/**
 * @brief: 清除cookie
 * @author: Scarlett Xiao
 * @Date: 2022-03-16 13:39:20
 */
export function clearCookie() {
  const paths = ['/'];
  const domains = [];
  const host = location.hostname;
  domains.push(host);
  if (host.indexOf('www') > -1) {
    domains.push(host.substr(3));
  }
  const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  const deleteCookie = function (name, path, domain) {
    const keys_sub = document.cookie.match(/[^ =;]+(?=\=)/g) || [];
    if (keys_sub.indexOf(name) < 0) {
      return;
    }
    document.cookie = name + '=' + ((path) ? ';path=' + path : '') + ((domain) ? ';domain=' + Domain.getDomain() : '') + ';expires=Thu,01-Jan-1970 00:00:01 GMT';
  };
  // 确保paths、domains、keys都不相同，都要进行清除
  paths && paths.forEach(p => {
    domains && domains.forEach((d) => {
      keys && keys.forEach(k => {
        deleteCookie(k, p, d);
      });
    });
  });
}